import styled from "styled-components";

export const AppStyle = styled.div`
  width: 100%;
  overflow-x: hidden;
  background-color: ${({ themed }) => (themed ? "#04031D" : "#f9f9f9")};
  color: ${({ themed }) => (themed ? "white" : "#04031D")};
  transition: all 1s ease-in-out;
  /* position: relative; */

  .audio {
    display: block;
    width: 80%;
    margin: auto;
    background: black !important;
  }

  .arrows.scroll {
    display: flex;
  }

  .arrows {
    /* content: "⮝"; */
    font-size: 50px;
    width: 50px;
    height: 50px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    color: orangered;
    border: 1px solid orangered;
    position: fixed;
    bottom: 20px;
    right: 20px;
    transition: all 0.5s ease-in-out;
    cursor: pointer;
    display: none;
  }
`;
export const Div = styled.div`
  @media (min-width: 1100px) {
    max-width: 90%;
    margin: auto;
    display: grid;
    grid-template-columns: 55% 45%;
    grid-gap: 3%;
    padding: 0 20%;
  }
  @media (min-width: 800px) {
    display: grid;
    grid-template-columns: 55% 45%;
    grid-gap: 3%;
    padding: 0 5%;
  }
`;
